import React, {useEffect} from "react"
import {connect} from "react-redux";
import * as layoutService from "../view/layoutService";
import {withMainLayout} from "../view/LayoutHOCs";
import {InfoBoxes} from "../info-boxes/InfoBoxes";
import {useHistory} from "react-router-dom";
import ViolationsTableSection from "./ViolationsTableSection";


const breadcrumbs = [
    {
        text: "Home",
        redirectTo: "/",
        iconClassName: "icon-home"
    },
    {
        text: "Violations",
        redirectTo: "/violations",
    }
]

function ViolationsPage() {

    const history = useHistory();

    useEffect(() => {
        layoutService.setPageTitle('MSB Violations')
        layoutService.setBreadcrumbs(breadcrumbs)
    }, [history.location])

    return (
        <>
            <InfoBoxes/>
            <ViolationsTableSection/>
        </>
    );
}


export default withMainLayout(connect()(ViolationsPage));